module.exports = __webpack_public_path__ + "media/images/ico-info-62161d46c72343838142c62170030bea.svg";